import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Button.module.css';
import clsx from 'clsx';
export const Button = ({ children, variant = 'primary', loading = false, disabled, className, ...props }) => {
    return (_jsx("button", { className: clsx(styles.button, loading && styles.loading, className), disabled: disabled || loading, ...props, children: loading ? 'Loading...' : children }));
};
